export const VERSION = '0.0.6'
